/* Pantheratec Produktseite: Desktop-Tabs, mobile Accordions und Fera-Einbindung.
   Native Shopify-Buy-Buttons und Zahlungsarten werden nicht veraendert. */
(() => {
  'use strict';
  if (window.__ptProductRedesignLoaded) return;
  window.__ptProductRedesignLoaded = true;

  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const all = (root, selector) => Array.from(root.querySelectorAll(selector));

  function boot(root = document) {
    all(root, '[data-ptp-tabs]').forEach((tabs) => {
      if (tabs.dataset.ptpInitialized === 'true') return;
      tabs.dataset.ptpInitialized = 'true';
      initTabs(tabs);
    });
  }

  function initTabs(tabs) {
    const nav = tabs.querySelector('.ptp-tabs__nav');
    const panels = tabs.querySelector('.ptp-tabs__panels');
    const tabButtons = all(nav, '[data-ptp-tab]');
    const panelByName = (name) => tabs.querySelector('[data-ptp-panel="' + name + '"]');
    let current = tabButtons.find((b) => b.getAttribute('aria-selected') === 'true')?.dataset.ptpTab || 'short';

    function setVisible(name, visible) {
      const button = tabButtons.find((b) => b.dataset.ptpTab === name);
      if (!button) return;
      if (name === 'faq' && tabs.dataset.ptpFaqEnabled !== 'true') visible = false;
      if (name === 'downloads' && tabs.dataset.ptpDownloadsEnabled !== 'true') visible = false;
      button.hidden = !visible;
      if (!visible && current === name) {
        const fallback = tabButtons.find((b) => !b.hidden);
        current = fallback?.dataset.ptpTab || 'short';
      }
      updatePanels();
    }

    function updatePanels() {
      tabButtons.forEach((button) => {
        const name = button.dataset.ptpTab;
        const panel = panelByName(name);
        if (!panel) return;
        const selected = !button.hidden && name === current;
        button.classList.toggle('is-active', selected);
        button.setAttribute('aria-selected', String(selected));
        button.setAttribute('aria-expanded', String(selected));
        panel.hidden = !selected;
        panel.tabIndex = selected ? 0 : -1;
      });
    }

    function activate(name, allowCollapse = false) {
      const button = tabButtons.find((b) => b.dataset.ptpTab === name && !b.hidden);
      if (!button) return;
      current = allowCollapse && current === name ? '' : name;
      updatePanels();
      if (name === 'reviews' && current === 'reviews') {
        // Fera's masonry widget may need new dimensions after becoming visible.
        requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
      }
    }

    function arrange() {
      if (mobileQuery.matches) {
        tabButtons.forEach((button) => {
          const panel = panelByName(button.dataset.ptpTab);
          if (panel && panel.previousElementSibling !== button) button.insertAdjacentElement('afterend', panel);
        });
      } else {
        tabButtons.forEach((button) => {
          const panel = panelByName(button.dataset.ptpTab);
          if (panel) panels.append(panel);
        });
      }
      updatePanels();
    }

    tabButtons.forEach((button, index) => {
      button.addEventListener('click', () => activate(button.dataset.ptpTab, mobileQuery.matches));
      button.addEventListener('keydown', (event) => {
        if (mobileQuery.matches || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const available = tabButtons.filter((b) => !b.hidden);
        const currentIndex = available.indexOf(button);
        if (!available.length) return;
        let targetIndex = currentIndex;
        if (event.key === 'ArrowRight') targetIndex = (currentIndex + 1) % available.length;
        if (event.key === 'ArrowLeft') targetIndex = (currentIndex + available.length - 1) % available.length;
        if (event.key === 'Home') targetIndex = 0;
        if (event.key === 'End') targetIndex = available.length - 1;
        const target = available[targetIndex];
        activate(target.dataset.ptpTab);
        target.focus();
      });
    });
    mobileQuery.addEventListener?.('change', arrange);
    arrange();
    // Der Bewertungstab bleibt auch bei 0 Bewertungen sichtbar.
    setVisible('reviews', tabs.dataset.ptpReviewEnabled === 'true');

    // Separate existing FAQ/Downloads accordions from the legacy Kurzinfos section.
    const shortLegacy = panelByName('short')?.querySelector('.ptp-tabs__legacy');
    if (shortLegacy) {
      all(shortLegacy, '.accordion').forEach((accordion) => {
        const heading = (accordion.querySelector('.details__summary')?.textContent || '').toLowerCase().trim();
        let destName = null;
        if (/faq|häufige fragen|fragen und antworten|fragen & antworten/.test(heading)) destName = 'faq';
        else if (/download|datenblatt|anleitung|pdf|dokument/.test(heading)) destName = 'downloads';
        if (!destName) return;
        const dest = panelByName(destName)?.querySelector('[data-ptp-' + destName + '-legacy]');
        if (!dest) return;
        dest.append(accordion);
        setVisible(destName, true);
      });
    }
    // Do not show empty FAQ / Download labels even if sections have empty metafields.
    ['faq', 'downloads'].forEach((name) => {
      const button = tabButtons.find((b) => b.dataset.ptpTab === name);
      const panel = panelByName(name);
      if (!button || !panel || button.hidden) return;
      const hasContent = Boolean(panel.querySelector('a[href], .accordion, .metafield-rich_text_field, .ptp-download-list li')) ||
        (panel.querySelector('.ptp-faq-content')?.textContent || '').trim().length > 0;
      if (!hasContent) setVisible(name, false);
    });

    function syncProductVariant() {
      const dataEl = document.getElementById('VariantData-' + tabs.dataset.ptpSection);
      if (!dataEl) return;
      try {
        const variants = JSON.parse(dataEl.textContent);
        const form = document.querySelector('form[action*="/cart/add"]');
        const id = form?.querySelector('input[name="id"]')?.value;
        if (!id) return;
        const found = variants.find((v) => String(v.id) === String(id));
        if (!found) return;
        const targets = {
          '[data-ptp-variant-sku]': found.sku || '',
          '[data-ptp-variant-barcode]': found.barcode || '',
          '[data-ptp-variant-weight]': found.weight_with_unit || ''
        };
        Object.entries(targets).forEach(([selector, value]) => {
          const element = tabs.querySelector(selector);
          if (element) element.textContent = value;
        });
      } catch (error) { /* Keep native variant controls working even if metadata is malformed. */ }
    }
    document.addEventListener('variant:change', () => setTimeout(syncProductVariant, 30));
    document.addEventListener('change', (event) => {
      if (event.target.matches('input[name="id"], select[name="id"]') || event.target.closest('variant-selects, variant-radios')) {
        setTimeout(syncProductVariant, 40);
      }
    });

    // Pantheratec v1.6 | Product Reviews: never hide the tab because no reviews
    // are present. Fera's official HTML widget is already rendered in Liquid.
    // If a separate Fera App Block is installed on the page, reuse its LIVE
    // container instead of displaying a second widget.
    function syncFeraReviews() {
      if (tabs.dataset.ptpReviewEnabled !== 'true') return;
      const target = panelByName('reviews')?.querySelector('[data-ptp-fera-target]');
      if (!target) return;
      const productId = String(tabs.dataset.ptpProductId || '');

      // Match both plain HTML-API widgets and initialized Fera App Blocks.
      const externalSource = all(document, '[data-fera-container="product_reviews"]')
        .find((el) => {
          if (target.contains(el)) return false;
          const sourceId = el.getAttribute('data-product-id');
          return !sourceId || String(sourceId) === productId;
        });
      if (!externalSource) return;

      const inlineFallback = target.querySelector('[data-ptp-fera-inline]');
      if (inlineFallback) inlineFallback.remove();
      if (externalSource.parentElement !== target) {
        target.append(externalSource);
        if (current === 'reviews') {
          requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
        }
      }
    }

    // Fera sometimes initializes after DOMContentLoaded. Its HTML API also
    // observes newly inserted nodes. Keep a short, bounded observer for app blocks.
    let scanQueued = false;
    function queueScan() {
      if (scanQueued) return;
      scanQueued = true;
      requestAnimationFrame(() => {
        scanQueued = false;
        syncFeraReviews();
      });
    }
    syncFeraReviews();
    const feraObserver = new MutationObserver(queueScan);
    if (tabs.dataset.ptpReviewEnabled === 'true') {
      feraObserver.observe(document.body, {childList: true, subtree: true});
      window.setTimeout(() => feraObserver.disconnect(), 12000);
      window.addEventListener('pagehide', () => feraObserver.disconnect(), {once: true});
    }

    // The native product star badge may link to #reviews; open the new tab first.
    document.addEventListener('click', (event) => {
      const reviewLink = event.target.closest('a[href="#reviews"], a[href$="#reviews"]');
      if (!reviewLink) return;
      const button = tabButtons.find((b) => b.dataset.ptpTab === 'reviews');
      if (!button || button.hidden) return;
      event.preventDefault();
      activate('reviews');
      tabs.scrollIntoView({behavior:'smooth', block:'start'});
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();

/* v1.5: Die native .buy-buttons-Zeile bereits Menge und Kaufen enthaelt.
   Keine DOM-Verschiebung: PayPal, Mengenregeln und Shopify-Events bleiben unveraendert. */
